module.exports = "<md-progress-bar mode=\"determinate\" value=\"{{progressVal}}\"></md-progress-bar>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/password-strength/password-strength.component.html
// module id = ./src/app/shared/password-strength/password-strength.component.html
// module chunks = main